import { render, staticRenderFns } from "./report-list.vue?vue&type=template&id=38a6fcce&scoped=true&"
import script from "./report-list.vue?vue&type=script&lang=js&"
export * from "./report-list.vue?vue&type=script&lang=js&"
import style0 from "./report-list.vue?vue&type=style&index=0&id=38a6fcce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a6fcce",
  null
  
)

export default component.exports